var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagementIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 17.504,
    viewBox: "0 0 17.5 17.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wpforms-brands_1",
    "data-name": "wpforms-brands 1",
    transform: "translate(0 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5,1.687V15.816A1.668,1.668,0,0,1,15.813,17.5H1.688A1.674,1.674,0,0,1,0,15.812V1.687A1.668,1.668,0,0,1,1.688,0H15.816A1.667,1.667,0,0,1,17.5,1.687ZM16.043,15.812V1.687a.232.232,0,0,0-.227-.227h-.363L11.145,4.375,8.75,2.426,6.359,4.375,2.051,1.457H1.688a.232.232,0,0,0-.227.227V15.812a.232.232,0,0,0,.227.227H15.816a.227.227,0,0,0,.227-.227ZM5.867,6.016V7.461H3V6.016Zm0,2.906v1.457H3V8.922ZM6.3,3.168,8.41,1.461H3.781L6.3,3.168Zm8.2,2.848V7.461H6.848V6.016Zm0,2.906v1.457H6.848V8.922ZM11.2,3.168l2.52-1.707H9.094L11.2,3.168Zm3.3,8.668v1.457H10.621V11.836Z",
    transform: "translate(0 1.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementIconBlue);
export default __webpack_public_path__ + "static/media/management-icon-blue.f923dbb7c82703384e447db4e5e06559.svg";
export { ForwardRef as ReactComponent };